import { atom } from "jotai"

export const isStickyActionStuckAtom = atom(false)
